(function () {
  'use strict';

  angular.module('app').component('paymentProviderDetail', paymentProviderDetail());

  function paymentProviderDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        company: '<',
        document: '<',
        showActionsFromModal: '<',
        onPaymentProviderSaved: '&',
        onPaymentProviderCanceled: '&',
      },
      controller: PaymentProviderDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/payment-providers/payment-provider-detail/payment-provider-detail.component.html',
    };
  }

  PaymentProviderDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'ModalWindowConfirmService',
    'SessionService',
    'AbilityService',
    'moment',
    'PaymentProviderService',
    'ProviderService',
    'DocumentTypeService',
    'ExchangeRateService',

    // Angular downgraded service
    'companyService',
    'currencyService',
  ];

  function PaymentProviderDetailComponent(
    config,
    UtilService,
    ModalWindowConfirmService,
    SessionService,
    AbilityService,
    moment,
    PaymentProviderService,
    ProviderService,
    DocumentTypeService,
    ExchangeRateService,

    // Angular downgraded service
    companyService,
    currencyService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_paymentprovider_accountadmin'),
      canUpdate: AbilityService.can('update_paymentprovider_accountadmin'),
    };

    vm.dateDisplay = config.DATE_DISPLAY;
    vm.dateDisplayShort = config.DATE_DISPLAY_SHORT;

    vm.purchaseTypes = config.PURCHASE_TYPES;

    vm.minTotalAmount = 0;
    vm.totalPrice = 0;
    vm.filterByDocumentNumber = '';
    vm.filterByDocumentType = [];

    // private properties
    let userLanguageCode = SessionService.getUserLanguage().code;

    vm.$onInit = function () {
      vm.companyTimeZoneUtc = vm.company.time_zone.utc;

      if (vm.item.id) {
        // view - edit
        setItemOptions(vm.item, vm.mode);

        // vm.documentDate = moment(vm.item.date);
        vm.documentDate = vm.UtilService.startOfDayFormat(vm.item.date); // yyyy-mm-ddT06:00:00.000Z
      } else {
        // new
        vm.createMode = true;

        // Initializers
        if (vm.document) {
          vm.paymentProviderDocuments = [];
          vm.paymentProviderDocuments.push(vm.item.payment_provider_document);
        }

        let item = {
          date: moment(),
          company_id: vm.company.id,
          user_id: SessionService.currentUser().id,
          currency: null,
          currency_id: null,
          provider: null,
          provider_id: null,
          amount: null,
        };

        vm.amountAppliedToDocuments = 0;

        if (!vm.document) {
          getCurrencies(vm.company.currency_ids);

          item.currency_id = vm.company.currency_id;
        } else {
          if (vm.document.currency.name === undefined) {
            getCurrencies(vm.company.currency_ids); // check
          }

          item.provider = vm.document.provider;
          item.provider_id = vm.document.provider_id;
          item.currency = vm.document.currency;
          item.currency_id =
            vm.document.currency_id === undefined
              ? vm.company.currency_id
              : vm.document.currency_id; // check
          item.amount = vm.item.amount;

          vm.minTotalAmount = vm.item.amount;
          vm.totalPrice = vm.item.amount;

          calculateAmountApplied();
        }

        vm.item = item;

        getDocumentTypes();

        vm.documentDate = moment();
        vm.outgoingPaymentMethods = vm.company.payment_methods.filter(
          (paymentMethod) => paymentMethod.outgoing
        );
      }
    };

    // public methods
    // -----------------------
    vm.selectDocumentType = function (documentType) {
      if (documentType.id === vm.lastDocumentTypeId) return;

      vm.documentType = documentType;
      vm.lastDocumentTypeId = documentType.id;

      setPaymentDatePicker(vm.documentType);
    };

    vm.onProviderSelected = function (provider) {
      vm.item.provider_id = provider.id;
      vm.item.provider = provider;

      vm.item.currency_id = provider.currency_id ? provider.currency_id : vm.companyBaseCurrencyId; // company.currency_id vm.companyBaseCurrencyId
      let currency = vm.currenciesPerCompany.find((item) => item.id === vm.item.currency_id);

      vm.selectCurrency(currency, true);

      if (vm.item.payment_method_code) {
        vm.item.payment_method_code = null;
        vm.item.payment_method_id = null;
      }

      // getOpenDocuments();
    };

    // When provider is empty
    vm.onProviderValidated = function (provider) {
      vm.item.provider = provider;

      if (!vm.item.provider && vm.item.provider_id) {
        resetProviderInput();
      }
    };

    vm.onProviderCleared = function (clearObj) {
      if (clearObj) {
        vm.item.provider = null;
      }

      resetProviderInput();
    };

    vm.selectCurrency = function (currency, setCurrency) {
      if (currency.id === vm.lastCurrencyId && !setCurrency) return;

      vm.item.currency = currency;
      vm.lastCurrencyId = currency.id;

      vm.documentDateExchangeRate = getDocumentDateExchangeRate(currency.id);

      vm.item.exchange_rate_value = vm.documentDateExchangeRate.value;
      vm.item.base_currency_symbol = vm.currenciesPerCompany.find(
        (x) => x.id === vm.company.currency_id
      ).symbol;

      vm.item.amount = 0;
      vm.amountAppliedToDocuments = 0;

      getOpenDocuments();
    };

    vm.setTodayExchangeRate = function () {
      vm.settingTodayExchangeRate = true;

      currencyService
        .setAutomaticExchangeRate(vm.item.currency, vm.companyTimeZoneUtc)
        .subscribe((response) => {
          if (response) {
            vm.documentDateExchangeRate.value = response.lastExchangeRate.rate;
            vm.item.exchange_rate_value = vm.documentDateExchangeRate.value;
          }

          vm.settingTodayExchangeRate = false;
        });
    };

    vm.selectAmount = function () {
      validateAmounts();
    };

    vm.openProviderInfoModal = function (provider) {
      ProviderService.openProviderInfoModal(provider);
    };

    vm.openRelatedTransactions = function () {
      PaymentProviderService.openRelatedTransactions(vm.item, vm.item.provider);
    };

    vm.payInFull = function (paymentProviderDocument) {
      if (paymentProviderDocument.pay_in_full) {
        paymentProviderDocument.amount = paymentProviderDocument.balance;
      } else {
        vm.paymentProviderDocuments.pay_in_full = false;
        paymentProviderDocument.amount = 0;
      }

      vm.validateAmount(paymentProviderDocument);
    };

    vm.payInFullDocuments = function (paymentProviderDocuments) {
      if (paymentProviderDocuments.length !== undefined) {
        if (paymentProviderDocuments.length > 0 && paymentProviderDocuments.pay_in_full === true) {
          paymentProviderDocuments.forEach(function (doc) {
            doc.pay_in_full = true;
            vm.payInFull(doc);
          });
        } else {
          paymentProviderDocuments.forEach(function (doc) {
            doc.pay_in_full = false;
            vm.payInFull(doc);
          });
        }
      }
    };

    vm.validateAmount = function (paymentProviderDocument) {
      if (!paymentProviderDocument.amount) {
        paymentProviderDocument.amount = !vm.createMode
          ? paymentProviderDocument.previousAmount
          : 0;
      } else if (paymentProviderDocument.amount <= 0 && !vm.createMode) {
        paymentProviderDocument.amount = paymentProviderDocument.previousAmount;
      }

      paymentProviderDocument.newBalance = vm.UtilService.roundNum(
        paymentProviderDocument.balance - paymentProviderDocument.amount
      );

      paymentProviderDocument.pay_in_full =
        paymentProviderDocument.amount === paymentProviderDocument.balance;

      calculateAmountApplied();
    };

    vm.removePaymentDocument = function (index) {
      vm.paymentProviderDocuments.splice(index, 1);
      calculateAmountApplied();
    };

    vm.openSearchOpenPayments = function () {
      let successCallback = function (openDocument) {
        vm.paymentProviderDocuments.push(openDocument);
        calculateAmountApplied();
      };

      let filterCriteria = {
        provider_id: vm.item.provider_id,
        currency_id: vm.item.currency_id,
        date_utc: vm.UtilService.currentDateUTCFormat(vm.item.date),
      };

      PaymentProviderService.openSearchOpenPayments(
        filterCriteria,
        vm.paymentProviderDocuments,
        successCallback
      );
    };

    vm.editPaymentProvider = function () {
      vm.editMode = true;
      vm.viewMode = false;

      getDocumentTypes();

      if (!vm.document) {
        getCurrencies(vm.company.currency_ids);
      }
    };

    /*vm.cancelEdit = function() {
            vm.item = vm.originalItem;

            setItemOptions(vm.item);
        };
        */

    vm.savePayment = function (isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;
        vm.UtilService.scrollToTop();

        return;
      }

      let createPayment = function () {
        vm.item.amount_in_excess = vm.amountInExcess;
        vm.item.payment_provider_documents = setPaymentProviderDocuments();

        vm.sendingForm = true;
        PaymentProviderService.savePaymentProvider(vm.item).then(function (data) {
          let status = data.status;
          let response = data.response;

          if (status) {
            // Success
            setItemOptions(response);

            vm.onPaymentProviderSaved({ item: response });
          } else {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
            vm.formErrors = true;
          }

          // vm.UtilService.scrollToTop();

          vm.sendingForm = false;
        });
      };

      if (!vm.amountInExcess) {
        createPayment();
      } else {
        let params = {
          mode: 'warning',
          title: 'AMOUNT_IN_EXCESS',
          body: 'AMOUNT_IN_EXCESS_NOTE',
        };

        ModalWindowConfirmService.open(params, createPayment);
      }
    };

    vm.cancel = function () {
      /*if (vm.editMode) {
                vm.cancelEdit();
                return;
            }*/

      vm.onPaymentProviderCanceled();
    };

    vm.filterByDocNumberType = function () {
      let filterDocumentValues = [];
      let selectedDocument = { pay_in_full: null, type: null };
      let filteredDocuments = [];

      if (vm.filterByDocumentType === undefined || vm.filterByDocumentNumber === undefined) {
        return;
      }

      if (vm.filterByDocumentType.length > 0) {
        for (let i = 0; i < vm.paymentProviderDocumentsCopy.length; i++) {
          selectedDocument = vm.paymentProviderDocumentsCopy[i];

          selectedDocument.pay_in_full = false;

          for (let x = 0; x < vm.filterByDocumentType.length; x++) {
            filterDocumentValues = vm.filterByDocumentType[x].value;

            if (selectedDocument.type === filterDocumentValues) {
              if (vm.paymentProviderDocuments.pay_in_full) {
                selectedDocument.pay_in_full = true;
              }
              filteredDocuments.push(selectedDocument);
            }
          }
        }
        vm.paymentProviderDocuments = filteredDocuments;
      }

      if (vm.filterByDocumentNumber !== '') {
        const matcher = new RegExp(`^${vm.filterByDocumentNumber.toUpperCase()}`, 'g');

        if (filteredDocuments.length === 0 && vm.filterByDocumentType.length > 0) {
          vm.paymentProviderDocuments = filteredDocuments;
        } else {
          vm.paymentProviderDocuments = vm.paymentProviderDocumentsCopy.filter(
            (doc) => doc.number !== null && doc.number.match(matcher)
          );
        }
      }

      if (vm.filterByDocumentNumber === '' && vm.filterByDocumentType.length === 0) {
        vm.paymentProviderDocuments = vm.paymentProviderDocumentsCopy;
      }

      calculateAmountApplied();
    };

    vm.selectPaymentMethod = function (paymentMethod) {
      vm.paymentMethod = paymentMethod;
      vm.receivedPayment = { payment_method_id: paymentMethod.id };
    };

    // private methods
    // -----------------------
    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        vm.editPaymentProvider();
      }

      vm.item.date = moment(item.date);

      setCompanyData(vm.company);

      setPaymentDocuments(item.payment_provider_documents);

      vm.originalItem = angular.copy(item); // store server data
    }

    function setPaymentDocuments(paymentProviderDocuments) {
      vm.paymentProviderDocuments = [];
      vm.minTotalAmount = 0;
      vm.totalPrice = 0;

      paymentProviderDocuments
        .filter((item) => item.document)
        .forEach(function (payment) {
          let document_id;
          let document_date;
          let payment_date;
          let type;
          let number;
          let total_price;
          let balance;
          let previousAmount;
          let newBalance;

          document_id = payment.document.document_id;
          document_date = payment.document.document_date;
          payment_date = payment.date;
          type = payment.document.type;
          number = payment.document.number;
          total_price = payment.document.total_price;
          balance = payment.balance;
          newBalance = payment.balance - payment.amount;
          previousAmount = payment.amount;

          vm.paymentProviderDocuments.push({
            id: payment.id,
            amount: payment.amount,
            document_id: document_id,
            document_date: document_date,
            type: type,
            number: number,
            total_price: total_price,
            newBalance: newBalance,
            balance: balance,
            previousAmount: previousAmount,
          });

          vm.minTotalAmount += vm.UtilService.roundNum(payment.balance_due);
          vm.totalPrice += vm.UtilService.roundNum(payment.document.total_price);
        });

      vm.paymentProviderDocumentsCopy = angular.copy(vm.paymentProviderDocuments);

      calculateAmountApplied();
    }

    function setCompanyData(company) {
      if (!company) {
        getCompany();
      } else {
        vm.outgoingPaymentMethods = company.payment_methods.filter((x) => x.outgoing);
        vm.paymentMethod = vm.outgoingPaymentMethods.find(
          (x) => x.code === vm.item.payment_method_code
        );
        vm.user = company.users.find((x) => x.id === vm.item.user_id);
      }
    }

    function getCompany() {
      vm.loadingCompany = true;
      companyService
        .getCompany(vm.item.company_id, {
          skip_check_role: true,
          lang: userLanguageCode,
        })
        .subscribe((response) => {
          vm.company = response;
          vm.outgoingPaymentMethods = vm.company.payment_methods.filter((x) => x.outgoing);

          vm.companyBaseCurrencyId = vm.company.currency_id;
          vm.companyCurrencyIds = vm.company.currency_ids;

          // Create / Edit
          // if (!vm.viewMode){
          //     getCurrencies(vm.companyCurrencyIds);
          // }

          // View / Edit
          // if (!vm.createMode) {
          if (vm.item.payment_method_code) {
            vm.paymentMethod = vm.outgoingPaymentMethods.find(
              (paymentMethod) =>
                paymentMethod.code === vm.item.payment_method_code && paymentMethod.outgoing
            );
          }

          vm.user = vm.company.users.find((user) => user.id === vm.item.user_id);
          // }

          vm.loadingCompany = false;
        });
    }

    function getDocumentTypes() {
      if (vm.documentTypes) return;

      let params = {
        get: 'active',
        transaction_type: 'payment_providers',
        skip_check_role: true,
      };

      vm.loadingDocumentTypes = true;
      DocumentTypeService.getDocumentTypes(params).then(function (data) {
        vm.documentTypes = data.items;

        // Preload default document type on create
        if (vm.createMode) {
          vm.documentType = vm.documentTypes.find(
            (documentType) => documentType.is_default === true
          );
          vm.item.document_type_id = vm.documentType.id;
        } else {
          vm.documentType = vm.documentTypes.find(
            (documentType) => documentType.id === vm.item.document_type_id
          );
        }

        vm.lastDocumentTypeId = vm.documentType.id;

        setPaymentDatePicker(vm.documentType);

        vm.loadingDocumentTypes = false;
      });
    }

    function calculateAmountApplied() {
      vm.amountAppliedToDocuments = 0;
      vm.minTotalAmount = 0;

      vm.paymentProviderDocuments.forEach(function (payment) {
        if (payment.amount) vm.amountAppliedToDocuments += vm.UtilService.roundNum(payment.amount);

        vm.minTotalAmount += vm.UtilService.roundNum(payment.balance);
      });

      validateAmounts();
    }

    function getCurrencies(companyCurrencyIds) {
      if (vm.currenciesPerCompany) return;
      let params = {
        get: 'per_company',
        'currency_ids[]': companyCurrencyIds,
        skip_check_role: true,
        time_zone_utc: vm.companyTimeZoneUtc,
        // documentDate: null,
      };

      if (!vm.createMode) {
        params.documentDate = vm.documentDate;
      }

      vm.loadingCurrenciesPerCompany = true;
      currencyService.getCurrencies(params).subscribe((response) => {
        vm.currenciesPerCompany = response;

        if ((!vm.document || !vm.document.currency_id) && vm.editMode) {
          vm.selectCurrency(vm.item.currency);
        }

        vm.loadingCurrenciesPerCompany = false;
      });
    }

    function setPaymentDatePicker(documentType) {
      let minDate = documentType.allows_past_days ? false : moment();
      let maxDate = documentType.allows_future_days ? false : moment();

      let onChangeDate = () => {
        vm.paymentProviderDocuments = [];

        calculateAmountApplied();
        getOpenDocuments();
      };

      vm.datePickerOptions = vm.UtilService.singleDatePickerOptions({
        minDate: minDate,
        maxDate: maxDate,
        dateDisplay: vm.dateDisplay,
        onChangeDate: onChangeDate,
      });
    }

    function resetProviderInput() {
      vm.item.provider_id = null;
      vm.item.currency_id = null;

      if (vm.item.payment_method_code) {
        vm.item.payment_method_code = null;
        vm.item.payment_method_id = null;
      }

      vm.paymentProviderDocuments = [];
    }

    function getDocumentDateExchangeRate(currencyId) {
      if (vm.item.provider_id === undefined) return;

      return ExchangeRateService.getDocumentDateExchangeRate(
        vm.currenciesPerCompany,
        vm.companyBaseCurrencyId,
        currencyId
      ); // vm.documentDate
    }

    function getOpenDocuments() {
      if (vm.item.provider_id && vm.item.date) {
        let filterCriteria = {
          provider_id: vm.item.provider_id,
          date_utc: vm.UtilService.currentDateUTCFormat(vm.item.date),
          by_reference_date: vm.item.date,
          currency_id: vm.item.currency.id,
        };

        vm.loadingOpenPaymentDocuments = true;
        PaymentProviderService.searchOpenPayments(filterCriteria).then(function (data) {
          vm.paymentProviderDocuments = data.sort((a, b) => (a.created_at < b.created_at ? 1 : -1));
          vm.minTotalAmount = 0;
          vm.totalPrice = 0;

          vm.paymentProviderDocuments.forEach(function (paymentProviderDocument) {
            paymentProviderDocument.newBalance = paymentProviderDocument.balance;
            paymentProviderDocument.amount = 0;

            vm.minTotalAmount += vm.UtilService.roundNum(paymentProviderDocument.balance);
            vm.totalPrice += paymentProviderDocument.total_price;
          });

          vm.paymentProviderDocumentsCopy = angular.copy(vm.paymentProviderDocuments);

          vm.loadingOpenPaymentDocuments = false;
        });
      }
    }

    function validateAmounts() {
      vm.errorAmountApplied = vm.item.amount < vm.amountAppliedToDocuments;

      vm.amountInExcess = 0;
      if (!vm.errorAmountApplied && vm.item.amount > vm.amountAppliedToDocuments) {
        vm.amountInExcess = vm.item.amount - vm.amountAppliedToDocuments;
      }
    }

    function setPaymentProviderDocuments() {
      let paymentProviderDocuments = [];
      vm.paymentProviderDocuments.forEach(function (paymentDocument) {
        if ((vm.createMode && paymentDocument.amount > 0) || vm.editMode) {
          let item = {
            amount: vm.UtilService.roundNum(paymentDocument.amount),
            balance: paymentDocument.balance,
            type: paymentDocument.type,
            document_id: paymentDocument.document_id,
            document_date: paymentDocument.document_date,
            payment_date: vm.item.date,
            id: null,
          };

          if (paymentDocument.id) item.id = paymentDocument.id;

          paymentProviderDocuments.push(item);
        }
      });

      return paymentProviderDocuments;
    }
  }
})();
